export const paymentStatusesCodes = {
    pending: "Pago pendiente",
    rejected: "Pago rechazado",
    approved: "Pago aprobado",
    failed: "Pago fallido",
    partial: "Pago parcial",
    wildcard: "Comodín"
};

export const paymentStatuses = {
    pending: "pending",
    rejected: "rejected",
    approved: "approved",
    failed: "failed",
    partial: "partial",
    wildcard: "wildcard"
};

export const paymentStatusesMessageClass = {
    pending: "text-theme-warning",
    approved: "text-theme-success",
    rejected: "text-danger",
    failed: "text-danger",
    partial: "text-blue-500",
    wildcard: "text-gray-600"
};
